<template>
  <div class="intelligent-container">
    <VerticalBanner
      :lists="carouselImgs"
      :indicatorPosition="'none'"
      :height="'640px'"
      :isShowMore="true"
    />
    <div class="module greyBg blurb">
      <div class="box" v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }">
        <div class="blurb-title">
          {{ blurb.title }}
        </div>
        <div class="blurb-desc text-wrap">{{ blurb.description }}</div>
        <img class="c_img" :src="blurb.img[0].url" alt="" srcset="" />
      </div>
    </div>
    <div class="module whiteBg">
      <div class="box">
        <div
          class="product jgpt"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ jgpt.title }}</div>
            <div class="subTitle">{{ jgpt.subTitle }}</div>
            <div class="desc text-wrap">{{ jgpt.description }}</div>
          </div>
          <button
            class="know-more-btn"
            @click="openUrl('/intelligent/management')"
          >
            了解更多 >
          </button>
        </div>
        <div class="jgpt-item">
          <el-row :gutter="40">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in jgpt.abilityList"
              :key="index"
            >
              <div
                class="item"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <img
                  src="../../../assets/images/intelligentImg/icon-check.png"
                  alt=""
                  srcset=""
                />
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <div v-for="(e, i) in item.description" :key="i">
                    {{ e }}
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="module whiteBg">
      <div class="box">
        <div
          class="product zhgd"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ zhgd.title }}</div>
            <div class="subTitle">{{ zhgd.subTitle }}</div>
            <div class="desc text-wrap">{{ zhgd.description }}</div>
          </div>
          <button
            class="know-more-btn"
            @click="openUrl('/intelligent/smartSite')"
          >
            了解更多 >
          </button>
        </div>
        <div class="zhgd-item">
          <el-row>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in zhgd.sceneList"
              :key="index"
            >
              <!-- 
                :class="['scene_' + (index + 1)]" -->
              <div
                class="item cursor-pointer"
                :class="[
                  [1, 2, 4, 5].includes(index) ? 'border-left-f7f7f7' : '',
                  [3, 4, 5].includes(index) ? 'border-top-f7f7f7' : '',
                ]"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <!-- <img class="c_img" :src="item.imgUrl" alt="" srcset=""> -->
                <div class="title">{{ item.title }}</div>
                <div class="desc text-wrap">
                  <div
                    class="text-wrap"
                    v-for="(e, i) in item.description"
                    :key="i"
                  >
                    {{ e }}
                  </div>
                  <!-- {{ item.description }} -->
                </div>
                <img
                  class="img"
                  :src="item.img"
                  :style="item.imgStyle"
                  alt=""
                />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="module whiteBg">
      <div class="box">
        <div
          class="product znlc"
          v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        >
          <div class="content">
            <div class="title">{{ znlc.title }}</div>
            <div class="subTitle">{{ znlc.subTitle }}</div>
            <div class="desc text-wrap">{{ znlc.description }}</div>
          </div>
          <button
            class="know-more-btn"
            @click="openUrl('/intelligent/prefabrication')"
          >
            了解更多 >
          </button>
        </div>
        <div class="znlc-item">
          <el-row :gutter="18">
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="8"
              :xl="8"
              v-for="(item, index) in znlc.abilityList"
              :key="index"
            >
              <div
                class="item"
                :class="'znlcItem_' + (index + 1)"
                v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
              >
                <div class="item-wrapper">
                  <div class="title">{{ item.title }}</div>
                  <div class="desc text-wrap">{{ item.description }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <ProductGet
      title="智能建造产品线"
      subTitle="在全球40多个重大基础设施工程建设中投入使用！"
      :bgImage="
        require('@/assets/images/intelligentImg/bg-advertising-smartSite.png')
      "
      :downLoadBtn="{
        label: '下载产品手册',
        fileUrl: '/download?anchor=manual',
        show: true,
      }"
      :contactBtn="{
        label: '',
      }"
    />
  </div>
</template>

<script>
import VerticalBanner from "@/components/VerticalBanner.vue";
import ProductGet from "@/components/ProductGet.vue";
export default {
  data() {
    return {
      // 轮播图
      carouselImgs: [
        {
          id: "1",
          icon: require("@/assets/images/intelligentImg/icon-logo-management.png"),
          title: "数字建设管理平台",
          subTitle: "集成高效管理，赋能智慧建设\n引领行业数字化转型",
          picUrl: require("@/assets/images/intelligentImg/carousel1.png"),
          bannerLink: "/intelligent/management",
        },
        {
          id: "2",
          icon: require("@/assets/images/intelligentImg/icon-logo-smartSite.png"),
          title: "数字智慧工地平台",
          subTitle: "以科技创新为引擎\n实现工地管理智能化、可视化与高效化",
          picUrl: require("@/assets/images/intelligentImg/carousel2.png"),
          bannerLink: "/intelligent/smartSite",
        },
        {
          id: "3",
          icon: require("@/assets/images/intelligentImg/icon-logo-prefabrication.png"),
          title: "工业化预制与建造平台",
          subTitle: "以科技创新为引擎\n实现工地管理智能化、可视化与高效化",
          picUrl: require("@/assets/images/intelligentImg/carousel3.png"),
          bannerLink: "/intelligent/prefabrication",
        },
      ],
      // 简介
      blurb: {
        title: "智能建造产品线 筑就智慧交通新未来",
        description:
          "江苏狄诺尼的智能建造产品线，以前沿科技为基，深度融合物联网、大数据、云计算、5G、人工智能以及 BIM 等先进技术，为交通工程建设领域打造了一套全流程、智能化、高效能的解决方案。从工程建设的前期规划到项目实施中的精细管控，再到工业化预制生产阶段的智能优化，实现了建设项目全生命周期的数字化升级。通过构建精准的数字孪生模型，实时反映工程实际状态，确保进度、质量、安全等关键环节紧密协同、精准把控，极大提升了整体建设效率与管理水平，推动交通工程建设行业从传统模式向智能建造的全面转变，开启智慧交通建设的新篇章，为打造高质量、现代化的交通基础设施提供了坚实可靠的技术支撑与保障。",
        img: [
          {
            id: "4",
            url: require("../../../assets/images/intelligentImg/BusinessArea.png"),
          },
        ],
      },
      // 建管平台
      jgpt: {
        title: "数字建设管理平台",
        subTitle: "—— 集成高效管理，赋能智慧建设",
        description:
          "数字建设管理平台是针对交通工程建设周期内各参与建设单位协同管理和办公的工程建设数字化综合管理平台 。聚焦工程建设中的进度质量、安全、计量、档案等核心业务，深度融合 BIM 技术实现工程建设项目的数字孪生，为交通工程建设数字化转型提供全新的技术手段。",
        abilityList: [
          {
            title: "BIM协同",
            description: ["核心业务数据BIM模型同步展示", "工程管理三维可视化"],
          },
          {
            title: "计划进度",
            description: ["项目计划编制丨实际进度反馈", "进度定期航拍对比"],
          },
          {
            title: "质量管理",
            description: ["工序报验丨材料溯源", "隐患管理（随手拍）"],
          },
          {
            title: "安全管理",
            description: ["安保体系丨风险管控", "危大工程丨隐患排查"],
          },
          {
            title: "计量支付",
            description: ["合同管理丨计量支付", "变更管理"],
          },
          {
            title: "电子档案",
            description: ["质量资料丨试验资料", "统计分析丨电子签章"],
          },
        ],
      },
      // 智慧工地
      zhgd: {
        title: "智慧工地平台",
        subTitle: "—— 实现管理智能化、可视化与高效化",
        description:
          "数字智慧工地平台基于先进的IoT、5G、大数据、BIM等技术，以分项工程为精细化管控对象，以虚拟施工为技术手段，进行项目质量、安全等可视化、集成化、协同化管理。",
        sceneList: [
          {
            title: "BIM建筑信息模型",
            description: ["构建高精度的三维模型", "实现信息的集成化管理"],
            img: require("@/assets/images/intelligentImg/scene_1.png"),
            imgStyle: { width: "188.5px", height: "124.5px" },
          },
          {
            title: "物联网（IoT）",
            description: ["精准掌控施工现场", "构建智能化管控网络"],
            img: require("@/assets/images/intelligentImg/scene_2.png"),
            imgStyle: { width: "192px", height: "155px" },
          },
          {
            title: "大数据",
            description: ["自主研发大数据分析平台", "高效驱动工程建设"],
            img: require("@/assets/images/intelligentImg/scene_3.png"),
            imgStyle: { width: "197.5px", height: "147.5px" },
          },
          {
            title: "5G技术",
            description: [
              "智能终端设备数据高速传递",
              "保障智能建造系统高效运行",
            ],
            img: require("@/assets/images/intelligentImg/scene_4.png"),
            imgStyle: { width: "122px", height: "150px" },
          },
          {
            title: "人工智能",
            description: ["自主学习深度", "分析预判工程风险隐患"],
            img: require("@/assets/images/intelligentImg/scene_5.png"),
            imgStyle: { width: "204.5px", height: "143px" },
          },
          {
            title: "激光点云",
            description: ["多维管理业务", "深度融合全掌握"],
            img: require("@/assets/images/intelligentImg/scene_6.png"),
            imgStyle: { width: "222px", height: "146px" },
          },
        ],
      },
      // 智能梁场
      znlc: {
        title: "工业化预制与建造平台",
        subTitle: "—— 标准化生产、精准化装配与全流程数字化管理",
        description:
          "工业化预制与建造平台遵循ISA95国际标准MES设计，综合运用大数据、云计算、5G、IoT、AI和BIM建造等技术，旨在组织工厂排产、提高生产效率、提升产品质量、减少生产周期，最终实现智能管理、智慧管控，打造「透明工厂」，由「制造」转向「智造」。",
        abilityList: [
          {
            title: "柔性化排程 ",
            description: "应用大数据精细化生产排程",
          },
          {
            title: "可视化管理",
            description: "多样式可视化决策报表",
          },
          {
            title: "智能仓储",
            description: "库位管理，先进先出",
          },
          {
            title: "全流程追溯",
            description: "一物一码，全程追溯",
          },
          {
            title: "透明化生产",
            description: "作业指令下达制程防错",
          },
          {
            title: "高效化设备",
            description: "设备台账设备；OEE综合效率",
          },
        ],
      },
    };
  },
  components: { VerticalBanner, ProductGet },
  methods: {
    // 页面路由跳转
    openUrl(path) {
      console.log("openUrl", path);
      this.$uniFun.openInCurrentTab(path);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.intelligent-container {
  .c_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .module {
    padding: 64px 0;
    .box {
      width: 1200px;
      margin: 0 auto;
    }
    .blurb-title {
      font-size: 24px;
      line-height: 24px;
      font-weight: 600;
      color: #333333;
      margin-bottom: 24px;
      text-align: center;
    }
    .blurb-desc {
      font-size: 16px;
      line-height: 32px;
      color: #333333;
      margin-bottom: 24px;
      text-indent: 2em;
      text-align: justify;
    }
    .product {
      padding: 58px 0 0 60px;
      margin-bottom: 2px;
      position: relative;
      .title {
        width: 640px;
        font-size: 28px;
        color: #ffffff;
        font-weight: 600;
        margin-bottom: 16px;
      }
      .subTitle {
        width: 640px;
        font-size: 20px;
        color: #ffffff;
        margin-bottom: 28px;
      }
      .desc {
        width: 640px;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        text-indent: 2em;
        text-align: justify; //两端对齐
      }
      .know-more-btn {
        position: absolute;
        left: 60px;
        bottom: 58px;
        padding: 8px 24px;
        background-color: #ffffff;
        color: #333333;
        border: 1px solid #ffffff;
        border-radius: 20px;
        cursor: pointer;
        font-size: 16px;
        align-self: flex-start; /* 按钮靠左 */
        transition: background-color 0.3s ease, color 0.3s ease;
        z-index: 20;
        &:hover {
          border: 1px solid #0035fb;
          color: #0035fb; /* 或者卡片的主题色 */
        }
      }
    }
    .jgpt {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-jgpt.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }

    .jgpt-item {
      .item {
        width: 100%;
        height: 140px;
        background: #ffffff;
        margin-top: 22px;
        padding: 24px 0 0 92px;
        position: relative;
        opacity: 0;
        img {
          width: 24px;
          height: 24px;
          position: absolute;
          top: 24px;
          left: 40px;
        }
        .title {
          font-size: 20px;
          line-height: 24px;
          color: #333333;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .desc {
          font-size: 16px;
          line-height: 32px;
          color: #666666;
          // > div::before {
          //   content: "";
          //   display: inline-block;
          //   width: 4px;
          //   height: 4px;
          //   background: #666666;
          //   border-radius: 50%;
          //   opacity: 0.8;
          //   margin-bottom: 5px;
          //   margin-right: 4px;
          // }
        }
      }
    }
    .zhgd {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-zhgd.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .zhgd-item {
      margin-top: 22px;
      .item {
        width: 100%;
        height: 200px;
        padding: 24px 0 0 24px;
        background: #ffffff;
        transition: all 0.5s ease-in-out;
        position: relative;
        &:hover {
          background: #0035fb;
          transition: all 0.5s ease-in-out;
          .title,
          .desc {
            color: #ffffff;
            > div::before {
              background: #ffffff;
            }
          }
        }
        .title {
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          line-height: 24px;
          text-align: left;
          margin-bottom: 8px;
          transition: all 0.5s ease-in-out;
        }
        .desc {
          font-weight: 400;
          font-size: 16px;
          color: #666666;
          line-height: 24px;
          text-align: left;
          transition: all 0.5s ease-in-out;
          // > div::before {
          //   content: "";
          //   display: inline-block;
          //   width: 4px;
          //   height: 4px;
          //   background: #999999;
          //   border-radius: 50%;
          //   opacity: 0.8;
          //   margin-bottom: 5px;
          //   margin-right: 4px;
          // }
        }
        .img {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }
      // .scene_1 {
      //   border-right: 1px solid #f7f7f7;
      //   border-bottom: 1px solid #f7f7f7;
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-1-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      // }
      // .scene_2 {
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-2-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      // }
      // .scene_3 {
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-3-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      // }
      // .scene_4 {
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-4-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      // }
      // .scene_5 {
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-5-current.png");
      //     transition: all 0.5s ease-in-out;
      //   }
      // }
      // .scene_6 {
      //   background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-defalut.png");
      //   background-size: 100% 100%;
      //   background-position: center;
      //   background-repeat: no-repeat;
      //   opacity: 0;
      //   &:hover {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      //   &.active {
      //     background-image: url("../../../assets/images/intelligentImg/bg-zhgd-scene-6-current.png");
      //     transition: all 0.5s ease-in-out;
      //     .title,
      //     .desc {
      //       color: #ffffff;
      //       > div::before {
      //         background: #ffffff;
      //       }
      //     }
      //   }
      // }
    }
    .znlc {
      width: 100%;
      height: 480px;
      background-image: url("../../../assets/images/intelligentImg/bg-znlc.png");
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      opacity: 0;
    }
    .znlc-item {
      .item {
        width: 100%;
        height: 240px;
        background: #ffffff;
        margin-top: 22px;
        position: relative;
        .item-wrapper {
          position: absolute;
          bottom: 20px;
          left: 24px;
          opacity: 1;
          transform: translateY(20px);
          transition: all 0.4s ease-out;
          .title {
            width: 240px;
            font-weight: bold;
            font-size: 20px;
            color: #ffffff;
            text-align: left;
            opacity: 1;
            transform: none;
            transition: opacity 0.4s ease-out;
          }
          .desc {
            width: 330px;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            text-align: left;
            margin-top: 12px;
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.4s ease-out, transform 0.4s ease-out;
          }
        }
      }
      .item:hover .item-wrapper {
        opacity: 1;
        transform: translateY(0);
      }
      .item:hover .item-wrapper .desc {
        opacity: 1;
        transform: translateY(0);
      }
      .znlcItem_1 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-1.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_2 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-2.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_3 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-3.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_4 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-4.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_5 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-5.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
      .znlcItem_6 {
        background-image: url("../../../assets/images/intelligentImg/bg-znlc-item-6.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
    }
  }

  .whiteBg {
    background: #ffffff;
  }
  .greyBg {
    background: #f4f8fb;
  }
  .border-left-f7f7f7 {
    border-left: 1px solid #f7f7f7;
  }
  .border-top-f7f7f7 {
    border-top: 1px solid #f7f7f7;
  }
}
</style>
